import React, { Component } from "react";
import firebase from "./Firebase.js";
import { withRouter } from "react-router";
const axios = require("axios");

class SlackAuth extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      name: "",
      pwd: "",
      signedIn: false,
      text: "",
      slackID: ""
    };
  }

  componentDidMount = () => {
    const { location } = this.props;

    const inputs = this.remove_character(
      "/slack-authentication/",
      location.pathname
    );
    const OR_flag = inputs.substr(0, 3);
    const slackID = inputs.substr(4, 9);
    const text = inputs.substr(14, inputs.length);
    var textCleaned = text.replace(/-/g, " ");
    console.log(slackID, textCleaned, OR_flag);
    this.setState({ OR_flag, slackID, text: textCleaned });
  };

  handleEmailInput = val => {
    this.setState({ email: val });
    console.log(this.state.email);
  };

  handleNameInput = val => {
    this.setState({ name: val });
    console.log(this.state.name);
  };

  handlePwdInput = val => {
    this.setState({ pwd: val });
    console.log(this.state.name);
  };

  handleLogin = async (email, password, flag) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(async firebaseUser => {
        console.log(firebaseUser);
        await firebase
          .database()
          .ref(`/users/${firebaseUser.user.uid}/userDetails`)
          .update({ slackToken: this.state.slackID });
      })
      .then(async () => {
        console.log(flag);
        if (flag === "ask") {
          const response = await axios({
            method: "POST",
            url: "https://us-central1-kinder-ef1d2.cloudfunctions.net/slackAsk",
            data: {
              user_id: this.state.slackID,
              text: this.state.text
            },
            headers: { "Access-Control-Allow-Origin": "*" }
          });
          console.log(response);
        } else if (flag === "off") {
          console.log("offer if");
          const response = await axios({
            method: "POST",
            url:
              "https://us-central1-kinder-ef1d2.cloudfunctions.net/slackOffer",
            data: {
              user_id: this.state.slackID,
              text: this.state.text
            },
            headers: { "Access-Control-Allow-Origin": "*" }
          });
          console.log(response);
        } else if (flag === "thx") {
          const response = await axios({
            method: "POST",
            url:
              "https://us-central1-kinder-ef1d2.cloudfunctions.net/slackShoutout",
            data: {
              user_id: this.state.slackID,
              text: this.state.text
            },
            headers: { "Access-Control-Allow-Origin": "*" }
          });
          console.log(response);
        }
        this.setState({ signedIn: true });
      })
      .catch(e => {
        // Error Handling of Invalid E-mail/Password/Non-Existant Account
        alert(
          `Invalid e-mail or password. Please try again or download the KinderUS app to sign up.`
        );
      });
  };

  remove_character(str_to_remove, str) {
    let reg = new RegExp(str_to_remove);
    return str.replace(reg, "");
  }

  render() {
    console.log(`Window width: ${this.props.width}`);
    const { email, name, pwd, slackID, text, OR_flag } = this.state;

    return (
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "100%",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "10%"
        }}
      >
        {!this.state.signedIn && (
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "100%",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <p>{text}</p>
            <input
              type="email"
              placeholder="email address"
              value={email}
              onChange={evt => this.handleEmailInput(evt.target.value)}
              style={{ width: "300px", marginBottom: "5px" }}
            />
            {/* <input
          type="text"
          placeholder="name"
          value={name}
          onChange={evt => this.handleNameInput(evt.target.value)}
          style={{width:"300px",marginBottom:"5px"}}

        /> */}
            <input
              type="Password"
              placeholder="password"
              value={pwd}
              onChange={evt => this.handlePwdInput(evt.target.value)}
              style={{ width: "300px", marginBottom: "5px" }}
            />

            <button onClick={() => this.handleLogin(email, pwd, OR_flag)}>
              Sign in
            </button>
          </div>
        )}
        {this.state.signedIn && (
          <div>
            <p>You're all set! Your post will show up in the feed shortly.</p>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(SlackAuth);
